export const statusFilterOptions = [
	{ value: 'all', label: 'Todas' },
	{ value: '3', label: 'Acertei' },
	{ value: '4', label: 'Errei' },
	{ value: '1', label: 'Resolvidas' },
	{ value: '2', label: 'Não resolvidas' },
]

export const commentFilterOptions = [
	{ value: 'all', label: 'Todos' },
	{ value: '1', label: 'Meus comentários' },
	{ value: '2', label: 'Minhas anotações' },
]
